import { render } from "./NewLeaveRequestView.vue?vue&type=template&id=2053cbd4"
import script from "./NewLeaveRequestView.vue?vue&type=script&lang=js"
export * from "./NewLeaveRequestView.vue?vue&type=script&lang=js"

import "./NewLeaveRequestView.vue?vue&type=style&index=0&id=2053cbd4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__